var $1ee2b6306238ec66$exports = {};
"use strict";
const $1ee2b6306238ec66$var$currentPage = window.location.pathname;
const $1ee2b6306238ec66$var$navLinks = document.querySelectorAll(".nav-link, .btn-contact");
const $1ee2b6306238ec66$var$logoLink = document.querySelector(".logo-link");
const $1ee2b6306238ec66$var$btnBackToTop = document.querySelector(".btn-back-to-top");
// Button back to top
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 300) $1ee2b6306238ec66$var$btnBackToTop.classList.add("active");
    else $1ee2b6306238ec66$var$btnBackToTop.classList.remove("active");
});
$1ee2b6306238ec66$var$btnBackToTop.addEventListener("click", ()=>{
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});
[
    ...$1ee2b6306238ec66$var$navLinks
].forEach((navLink)=>navLink.addEventListener("click", function() {
        const sectionTopPosition = document.getElementById(this.dataset.section).getBoundingClientRect().top;
        window.scrollTo({
            top: sectionTopPosition + window.scrollY,
            behavior: "smooth"
        });
    }));
// Prevent refresh page on click if already on homepage
if ($1ee2b6306238ec66$var$currentPage === "/") {
    $1ee2b6306238ec66$var$logoLink.addEventListener("click", (e)=>{
        e.preventDefault();
    });
    $1ee2b6306238ec66$var$logoLink.style.pointerEvents = "none";
}


//# sourceMappingURL=index.0b2bb7ca.js.map
